module.exports = __webpack_public_path__ + "img/pingan.592b0281.png";